const processEnvMap = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_WEB_HOSTS: process.env.REACT_APP_WEB_HOSTS,
  REACT_APP_KEYCLOAK_URL: process.env.REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_REALM: process.env.REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_CLIENT_ID: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_STRIPE_PRICE_ID_PRO: process.env.REACT_APP_STRIPE_PRICE_ID_PRO,
  REACT_APP_VERSION: process.env.REACT_APP_VERSION,
};

// Runtime values (env-config.js, written by entrypoint.sh) win over build-time ones.
const raw = (key) => (window._env_ && window._env_[key]) || processEnvMap[key];

// Which API a page talks to depends on the host that served it. The platform's
// own web app (REACT_APP_WEB_HOSTS, e.g. app.vellby.com) talks to the platform
// API (REACT_APP_API_URL, e.g. https://api.vellby.com). A pooled node is served
// on ONE host — <slug>.vellby.com, or its own domain — with its API under /api
// on that same host (docs/node-pooling.md), so a page on any other host talks
// to its own origin, and learns its realm from that origin's /info. With
// REACT_APP_WEB_HOSTS unset (local dev, older images) REACT_APP_API_URL applies
// everywhere, as before.
const apiUrl = () => {
  const configured = raw('REACT_APP_API_URL');
  const webHosts = (raw('REACT_APP_WEB_HOSTS') || '')
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
  if (!configured || webHosts.length === 0) return configured;
  return webHosts.includes(window.location.hostname.toLowerCase()) ? configured : window.location.origin;
};

const getEnv = (key) => (key === 'REACT_APP_API_URL' ? apiUrl() : raw(key));
export default getEnv;
